import { api } from '@/lib/api'
import type {
  CreateSchedulePayload,
  Schedule,
  ScheduleDetailResponse,
} from './types'

export const fixedAssetsApi = {
  list: () => api.get<Schedule[]>('/api/schedules/depreciation'),
  detail: (id: number) =>
    api.get<ScheduleDetailResponse>(`/api/schedules/depreciation/${id}`),
  create: (body: CreateSchedulePayload) =>
    api.post<{ id?: number; message?: string }>('/api/schedules/', body),
  // Partial update (soft-edit). Description / category / accounts can
  // be changed any time; amount/dates only when no entries are posted.
  update: (id: number, body: Partial<CreateSchedulePayload>) =>
    api.put<{ id?: number; message?: string }>(`/api/schedules/${id}`, body),
  remove: (id: number) => api.del<{ message?: string }>(`/api/schedules/${id}`),
}
